import MenuItem from '@mui/material/MenuItem'
import ListItemText from '@mui/material/ListItemText'
import Select, { SelectChangeEvent, selectClasses } from '@mui/material/Select'
import { useInvestments } from '@services/protocols/protocols.hook'
import { useUserRoles } from '@services/token/token.hooks'
import { Box, Typography } from '@mui/material'
import BuildIcon from '@mui/icons-material/Build'

export default function SelectContent() {
  const { investments, investment, setInvestment } = useInvestments()
  const { isTechnician } = useUserRoles()

  // If user is a technician, display Helpdesk header instead of investment selection
  if (isTechnician()) {
    return (
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, p: 1 }}>
        <BuildIcon color='primary' />
        <Typography variant='subtitle1' fontWeight='bold'>
          Helpdesk
        </Typography>
      </Box>
    )
  }

  const handleChange = (event: SelectChangeEvent) => {
    setInvestment(Number(event.target.value))
  }

  return (
    <Select
      labelId='investment-select'
      id='investment-select'
      value={investment?.toString() || ''}
      onChange={handleChange}
      displayEmpty
      inputProps={{ 'aria-label': 'Wybierz inwestycje' }}
      fullWidth
      sx={{
        maxHeight: 56,
        width: '100%',
        '&.MuiList-root': {
          p: '8px'
        },
        [`& .${selectClasses.select}`]: {
          display: 'flex',
          alignItems: 'center',
          gap: '2px'
        },
        '.MuiTypography-root': {
          overflow: 'hidden',
          textOverflow: 'ellipsis'
        }
      }}
    >
      {investments.map(({ id, name }) => (
        <MenuItem key={`investment_${id}`} value={id}>
          <ListItemText primary={name} />
        </MenuItem>
      ))}
    </Select>
  )
}
